import { EventSnippet } from '../../interop/webmodule-interop';

import { WaitPatiently } from './modal-spinner';
import { LangModalLoading } from '../../../localization/webmodule-common/other/ui/modal-loading-lang';

export function waitPatientlyLoading(title?: EventSnippet, message?: EventSnippet) {
  const modal = new WaitPatientlyLoading();
  modal.eventTitle = title ?? (() => LangModalLoading.loading());
  modal.message = message ?? (() => LangModalLoading.justAMoment());

  modal.delayedShow();
  return modal;
}

//a progress window default to run will doing a save to the server
export class WaitPatientlyLoading extends WaitPatiently {
  get borderType() {
    return 'basic';
  }
}
